"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirectURL = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_1 = require("@react-navigation/native");
const images_1 = require("../../services/images");
const request_1 = __importStar(require("../../http/request"));
const handleError_1 = require("../../http/handleError");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const userHandlers_1 = require("../../handlers/userHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const helper_1 = require("../../services/helper");
const getRedirectURL = async (path) => {
    try {
        const response = await (0, request_1.default)(request_1.GET, path);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getRedirectURL = getRedirectURL;
const Redirector = () => {
    const decodedUrl = (url) => url ? atob(url) : null;
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'redirector' });
    const isAuthenticated = (0, react_redux_1.useSelector)(selectors_1.getIsAuthenticated);
    const [redirectType, setRedirectType] = (0, react_1.useState)(null);
    const [redirectUrl, setRedirectUrl] = (0, react_1.useState)(null);
    const [message, setMessage] = (0, react_1.useState)(null);
    const navigation = (0, native_1.useNavigation)();
    let apiProxyRedirect = false;
    const RedirectingDirectTypesArray = ['paid_flight', 'payment_gateway', 'declined_flight'];
    const RedirectingApiProxyTypesArray = ['payment_verify'];
    const selectType = (type) => {
        /*
            return [message, apiProxyRedirect]
         */
        if (RedirectingDirectTypesArray.includes(type)) {
            return [t(type), false];
        }
        if (RedirectingApiProxyTypesArray.includes(type)) {
            return ['', true];
        }
        return null;
    };
    (0, react_1.useEffect)(() => {
        if (isAuthenticated) {
            (0, userHandlers_1.getUserDetailsHandler)();
        }
        const urlParams = new URLSearchParams(window.location.search);
        let paramsRedirectType = urlParams.get('type');
        let encodedRedirectUrl = urlParams.get('redirect_url');
        if (Array.isArray(selectType(paramsRedirectType))) {
            setRedirectType(paramsRedirectType);
            setRedirectUrl(decodedUrl(encodedRedirectUrl));
        }
        else {
            navigation.navigate("LandingPage");
        }
    }, []);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    (0, react_1.useEffect)(() => {
        if (userDetails?.language != null)
            (0, helper_1.setUserLanguage)(userDetails.language);
        apiProxyRedirect = false;
        const type = selectType(redirectType);
        if (type) {
            setMessage(type[0]);
            apiProxyRedirect = type[1];
        }
        if (redirectUrl && apiProxyRedirect) {
            (0, exports.getRedirectURL)(redirectUrl).then((data) => {
                setRedirectType(data.type);
                setRedirectUrl(decodedUrl(data.redirect_url));
            }).catch(error => {
                console.log(error);
            });
        }
        if (redirectUrl && !apiProxyRedirect) {
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 5000);
        }
    }, [redirectType, userDetails]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "page", style: {
            backgroundImage: `url(${images_1.images.cloud})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'top -200px',
            position: 'fixed',
        }, children: (0, jsx_runtime_1.jsxs)("div", { className: "page-container", style: { textAlign: 'center' }, children: [(0, jsx_runtime_1.jsx)("img", { alt: "flyway-logo", className: "logo-central", src: images_1.images.logoHorizontal, onClick: () => navigation.navigate("LandingPage") }), (0, jsx_runtime_1.jsx)("div", { className: "dotted-spinner-container", children: (0, jsx_runtime_1.jsx)("div", { className: "dotted-spinner" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "font-16-400", children: message }) }), redirectUrl && !apiProxyRedirect && message !== "" &&
                    (0, jsx_runtime_1.jsx)("div", { style: { marginTop: 20 }, children: (0, jsx_runtime_1.jsxs)("span", { className: "font-12-400", children: [t('redirect_hint'), " ", (0, jsx_runtime_1.jsx)("a", { href: redirectUrl, children: t('redirect_hint_link') })] }) })] }) }));
};
exports.default = Redirector;
